import { AfterViewInit, Component, TemplateRef, ViewChild, inject, signal } from '@angular/core';

import { MainMenuComponent, Menu } from '@camelot/menu';
import { BulletComponent } from '@camelot/notification';
import { MyAccountComponent } from '@camelot/user';

import { BaseComponent } from 'src/app/features/core/abstract/base-component';
import { AppMenuService } from 'src/app/services/menus.service';

@Component({
  imports: [BulletComponent, MainMenuComponent, MyAccountComponent],
  selector: 'app-menu-main',
  styleUrls: ['./menu-main.component.scss'],
  templateUrl: './menu-main.component.html',
})
export class MenuMainComponent extends BaseComponent implements AfterViewInit {
  @ViewChild('accountTemplate') accountTemplate!: TemplateRef<any>;
  @ViewChild('notifBulletTemplate') notifBulletTemplate!: TemplateRef<any>;

  private readonly _menuService = inject(AppMenuService);

  public menu = this._menuService.getMainMenu();
  public userMenu = signal<Menu | null>(null);

  ngAfterViewInit() {
    this.userMenu.set(this._menuService.getUserMenu(this.accountTemplate, this.notifBulletTemplate));
  }

  constructor() {
    super();
  }
}
